import { axiosInstance } from '@configs/axios/axiosInstance';

import type {
  GetInvoiceAlertsRequest,
  GetInvoiceAlertsResult,
} from './getInvoiceAlerts.types';

export async function getInvoiceAlerts({
  organizationId,
}: GetInvoiceAlertsRequest): Promise<GetInvoiceAlertsResult> {
  const response = await axiosInstance.get<GetInvoiceAlertsResult>(
    '/invoices/alerts',
    {
      headers: {
        'X-Organization-Id': organizationId,
      },
    }
  );
  return response.data;
}
